import { APP_CONFIG } from 'mangools-commons/dist/configs/app'
import queryString from 'query-string';
import { parse } from 'sources/parsers/ResultDataParser';

import ErrorCodes from 'mangools-commons/dist/constants/ErrorCodes';
import HumanService from 'mangools-commons/dist/services/HumanService';

// Constants
const ENDPOINT = '/links';

/**
 * Data source class handling retrieval of backlink data from query.
 */
class ResultSource {
    /**
     * gets data from Link source to get backlink data
     *
     * @static
     * @param {string} page For pagination purposes.
     * @param {string} source What is the default sort of backlink data
     * @param {string} url URL for which we want backlink data
     *
     */
    static getData({ accessToken }, { linksPerDomain, page, source, url }) {
        const pageParam = page > 0 ? page - 1 : 0;

        const requestQuery = queryString.stringify({
            links_per_domain: linksPerDomain,
            page: pageParam,
            source,
            url,
        });

        const requestURL = `${APP_CONFIG.API_HOST}${APP_CONFIG.API_PATH}${ENDPOINT}?${requestQuery}`;

        return fetch(requestURL, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-Access-Token': accessToken || '',
                'X-Human-Token': HumanService.gen(),
                'X-Mangools-Client': 'app',
            },
        })
            .then(response => {
                if (response.ok) {
                    return response
                        .json()
                        .then(data => ({
                            error: false,
                            payload: parse(data),
                        }))
                        .catch(ex => ({
                            error: true,
                            payload: {
                                requestURL,
                                status: ErrorCodes.PARSE_ERROR,
                                text: ex.toString(),
                            },
                        }));
                } else {
                    return response.json().then(e => ({
                        error: true,
                        payload: {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                        },
                    }));
                }
            })
            .catch(ex => ({
                error: true,
                payload: {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                },
            }));
    }
}

export default ResultSource;
